import * as Mutations from "./mutation-types"
import * as Actions from "./action-types"
import * as api from "@/api/api"
import * as Helpers from "@/helpers"
import { Tabs } from "@/constants/appConstants"
import _ from "lodash";

const defaultChannelsQuery = {
    type: "SiteQueryModel",
    start_date: "",
    end_date: "",
    provider_keys: [],
    grouptime: "day",
    weekdays: [],
    target_group: [],
}
const defaultChannelsRoFQuery = {
    measureType: "absolute",
    aggregationType: "cumulative",
    maxFreq: 10,
    targetGroup: null,
}
const state = {
    queryCost: {
        data: null,
        isLoading: false,
        error: null,
    },
    channelsInitStatus: "NOT_LOADED",
    channelsQuery: _.cloneDeep(defaultChannelsQuery),
    channelsQueryDefault: _.cloneDeep(defaultChannelsQuery),
    channelsHasSetDefaultQuery: false,
    channelsRoFQuery: {
        ...defaultChannelsRoFQuery,
    },
    channelsQueryForApi: {},
    channelsExportQuery: {
        include_detail_rows: true,
        include_header: true,
    },
    channelsResults: {
        status: "NOT_LOADED",
    },
    channelsRoFResults: {
        status: "NOT_LOADED",
    },
    channelsHaveSelectedRow: false,
    channelsColumnTypes: [],
    channelsDefaultColumns: [],
    channelsProviders: [],
    channelsSelectedChannelInfo: {},
    channelsQueryBeforeChange: {},
    channelsStringForFilterBeforeChange: "",
    channelsHasExcludedRow: false,
    channelsSumVisible: false,
}

const convertFromQueryToQueryForAPI = query => {
            // transform internal queryObject to one that fits our API

    let targetGroupsChannels = query.target_group
    const APIQuery = {
        type: "SiteQueryModel",
        start_date: query.start_date,
        end_date: query.end_date,
        provider_keys: query.provider_keys,
        grouptime: query.grouptime,
        measures: targetGroupsChannels,
        weekdays: query.weekdays,
    }
    return APIQuery
}

const executeQuery = async (context, query) => {
    context.commit(Mutations.setChannelsQueryForApi, query)
    try {
        context.commit(Mutations.setChannelsExportQuery, { ...context.getters.getChannelsExportQuery, ...query })
        context.commit(Mutations.setChannelsResults, {
            status: "LOADING",
            data: null,
        })
        let r = await api.executeSiteQuery(query)
        let columns = context.getters.getChannelsQuery.columns
        // got a response

        // check if we got any rows
        if (r.sites.length == 0) {
            context.commit(Mutations.setChannelsResults, {
                status: "EMPTY_RESULT",
            })
        } else {
            let levelOneSitesWithLevelTwoSites = r.sites
                .filter(s => s.isParent)
                .map((s, i) => {
                    for (let i = 0; i < s.measures.length; i++) {
                        if (s.measures[i].trim().length == 0) {
                            s[`measure_${i + 1}`] = "0"
                        } else {
                            s[`measure_${i + 1}`] = s.measures[i]
                        }
                    }
                    let levelTwoSites = r.sites
                        .filter(lv2p => lv2p.siteName === s.siteName && !lv2p.isParent && lv2p.date === s.date)
                        .map(s => {
                            for (let i = 0; i < s.measures.length; i++) {
                                if (s.measures[i].trim().length == 0) {
                                    s[`measure_${i + 1}`] = "0"
                                } else {
                                    s[`measure_${i + 1}`] = s.measures[i]
                                }
                            }
                            return {
                                ...s,
                                chosen: false,
                            }
                        })
                    Helpers.setLevelOneValuesForChannels(s, levelTwoSites)
                    return {
                        ...s,
                        levelTwoSites: levelTwoSites,
                        index: i,
                        chosen: false,
                    }
                })
            let fields = context.getters.getChannelsColumnTypes
                .filter(c => columns.includes(c.value))
                .map(c => {
                    return {
                        key: c.value,
                        label: c.text,
                        sortable: true,
                        isMeasure: false,
                    }
                })
            for (const field of fields) {
                if (field.key === "date" || field.key === "week") {
                    field.thClass = "date-th"
                }
            }
            let fieldsMeasures = []
            for (let i = 0; i < r.measureHeaders.length; i++) {
                fieldsMeasures.push({
                    key: `measure_${i + 1}`,
                    label: `${r.measureHeaders[i].header} ${r.measureHeaders[i].subHeader}`,
                    header: r.measureHeaders[i].header,
                    subHeader: r.measureHeaders[i].subHeader,
                    sortable: true,
                    tdClass: "measureTdClass",
                    isMeasure: true,
                })
            }
            let selectedSpecificChannel = context.getters.getChannelsSelectedChannelInfo.selectedSpecificChannel ? true : false
            let foundReachTargetGroup = query.measures.some(m => m.measure === "reach")
            let setReachAgeGroupToA3ToA99 = selectedSpecificChannel && foundReachTargetGroup
            context.commit(Mutations.setChannelsResults, {
                status: "LOADED",
                showSelectSpecificChannelError: setReachAgeGroupToA3ToA99,
                data: {
                    levelOneSitesWithLevelTwoSites: levelOneSitesWithLevelTwoSites,
                    columns: [...fields, ...fieldsMeasures],
                    summary: r.summary,
                    excludedRows: [],
                },
            })
        }
    } catch (error) {
        context.commit(Mutations.setChannelsResults, {
            status: "FAILED",
            data: null,
            error: error,
        })
    }
}
const actions = {
            // fetch all data required to display the page
    [Actions.getChannelsProviders]: async context => {
        const providerObjects = await api.getProviders(Tabs.ChannelTab)
        const providers = Object.keys(providerObjects).map(k => providerObjects[k])
        await context.commit(Mutations.setChannelsProviders, providers)
        return providers
    },
    [Actions.getChannelsColumnTypes]: async () => {
        return await api.getColumnTypes("SITES")
    },
    [Actions.getChannelsMeasures]: async () => {
        return await api.getMeasures("SITES")
    },

            // this initializes the table and query, so use when pressing 'Search'
    [Actions.executeChannelsQuery]: async context => {
        context.commit(Mutations.setChannelsResults, {
            status: "LOADING",
            data: null,
        })

        // preppa query
        const query = convertFromQueryToQueryForAPI(context.state.channelsQuery)
        context.commit(Mutations.setChannelsExportQuery, { ...context.getters.getChannelsExportQuery, ...query })

        // check if the query is OK to run and return to the interface, otherwise set queryCost so we handle it from there
        context.commit(Mutations.setQueryCostLoading, true)
        context.commit(Mutations.setQueryCostError, null)

        try {
            const queryCostData = await api.getQueryCostSites(query)
            await context.commit(Mutations.setQueryCostData, queryCostData)
        } catch (error) {
            await context.commit(Mutations.setQueryCostError, error)
        } finally {
            await context.commit(Mutations.setQueryCostLoading, false)
        }

        if (context.state.queryCost.error == null && context.state.queryCost.data.queryClass == "Normal") {
            await context.commit(Mutations.setChannelsQueryForApi, query)
            await executeQuery(context, query)
        } else {
            context.commit(Mutations.setChannelsResults, {
                status: "NOT_LOADING",
                data: null,
            })
        }
    },
            //initializes csv-export request for channels, use when pressing 'Export'
    [Actions.executeExportChannelsQuery]: async context => {
        let status = context.getters.getChannelsResults.status
        const query = context.getters.getChannelsExportQuery
        query.include_summary_row = false
        if (query.include_header) {
            query.headeritems = Helpers.getHeaderChannelTab(context, "Channels, list tab")
        }
        if (status === "LOADED") {
            query.row_keys = context.getters.getChannelsResults.data.levelOneSitesWithLevelTwoSites
                .flatMap(s => s.levelTwoSites)
                .map(function(channel) {
                    return { key: channel.providerKey, date: channel.date }
                })
            query.excludedRows = context.getters.getChannelsResults.data.excludedRows
        }
        return await api.executeExportChannelsQuery(query)
    },

    [Actions.executeScheduleQuery]: async (context, options) => {
        const query_x = convertFromQueryToQueryForAPI(context.state.channelsQuery)
        context.commit(Mutations.setChannelsExportQuery, { ...context.getters.getChannelsExportQuery, ...query_x })
        const query = context.getters.getChannelsExportQuery
        query.include_summary_row = false

        let rowkeys = null

        // sometimes we don't have any data, e.g. when we haven't run a query before exporting
        if (context.getters.getChannelsResults.data) {
            rowkeys = context.getters.getChannelsResults.data.levelOneSitesWithLevelTwoSites
                .flatMap(s => s.levelTwoSites)
                .map(function(channel) {
                    return { key: channel.providerKey, date: channel.date }
                })
        }
        query.row_keys = rowkeys
        if (query.include_header) {
            query.headeritems = Helpers.getHeaderChannelTab(context, "Channels, list tab")
        }

        return await api.createScheduledReportQuery(options.reportname, query)
    },

    [Actions.executeChannelsRoFQuery]: async context => {
        try {
            context.commit(Mutations.setChannelsRoFResults, {
                status: "LOADING",
                data: null,
            })
            let rowkeys = context.getters.getChannelsResults.data.levelOneSitesWithLevelTwoSites
                .map(s => s.levelTwoSites)
                .reduce(function(pre, cur, i) {
                    let preArray = i === 1 ? Helpers.convertToRowkeysArraySite(pre) : pre
                    let rowKeysArray = Helpers.convertToRowkeysArraySite(cur)
                    return preArray.concat(rowKeysArray)
                })
            let rofQuery = {
                ...context.getters.getChannelsRoFQuery,
                startDate: context.getters.getChannelsQueryForApi.start_date,
                endDate: context.getters.getChannelsQuery.end_date,
                rowKeys: rowkeys,
            }
            var r = await api.executeChannelsRoFQuery(rofQuery)
            // save results formatted according to query
            const formatFunc = function(val) {
                return context.getters.getChannelsRoFQuery.measureType == "absolute" ? Math.round(val / 1000, 0).toLocaleString("sv-Sv") : `${Math.round(val * 1000) / 10}`
            }

            context.commit(Mutations.setChannelsRoFResults, {
                status: "LOADED",
                data: {
                    ...r,
                    frequencyMatrix: r.frequencyMatrix.map(row => row.map(cell => formatFunc(cell))),
                    reach1PlusAcc: r.reach1PlusAcc.map(cell => formatFunc(cell)),
                    averageFrequency: r.averageFrequency,
                    rating: r.rating.map(cell => formatFunc(cell)),
                },
                tableData: {
                    initialTableColumns: [],
                    initialTableItem: [],
                    roFColumns: [],
                    allRofRows: [],
                },
            })
        } catch (error) {
            context.commit(Mutations.setChannelsRoFResults, {
                status: "FAILED",
                data: null,
                error: error,
            })
        }
    },
    [Actions.executeChannelsRoFExport]: async context => {
        try {
            let channelsQuery = context.getters.getChannelsQuery
            let rofTableData = { ...context.getters.getChannelsRoFResults.tableData }
            const rofTableDataCopy = JSON.parse(JSON.stringify(rofTableData))
            const initialTableColumns = rofTableDataCopy.initialTableColumns.map(obj => obj.label).join(";")
            rofTableDataCopy.initialTableItem[0].channelNames = [
                ...new Set(
                    context.getters.getChannelsResults.data.levelOneSitesWithLevelTwoSites
                        .filter(p => p.chosen)
                        .map(p => p.levelTwoSites)
                        .flat()
                        .map(p => p.providerName)
                ),
            ]
                .sort()
                .join(", ")
            const initialTableItem = rofTableDataCopy.initialTableItem
                .map(row => {
                    let csvInitialRowData = []
                    for (const column of rofTableDataCopy.initialTableColumns) {
                        csvInitialRowData.push(row[column.key])
                    }
                    return csvInitialRowData.join(";")
                })
                .join("\n")
            let csvContent = `${initialTableColumns}\n${initialTableItem}`
            if (rofTableDataCopy.roFColumns.length > 0) {
                csvContent += `\n\n${rofTableDataCopy.roFColumns.map(obj => obj.label).join(";")}`
                for (const row of rofTableDataCopy.allRofRows) {
                    let csvAllRofRowsData = []
                    for (const column of rofTableDataCopy.roFColumns) {
                        csvAllRofRowsData.push(row[column.key] ?? "")
                    }
                    csvContent += `\n${csvAllRofRowsData.join(";")}`
                }
            }
            let fileName = `${context.getters.getExcelExportFilePreName} CROSS-PLATFORM_ChannelsRoF_${channelsQuery.start_date}_${channelsQuery.end_date}.csv`
            Helpers.downloadBlob(csvContent, fileName, "text/csv;charset=utf-8;")
        } catch (error) {
            console.error(error)
        }
    },
}

const getters = {
    getChannelsQueryDefault: state => state.channelsQueryDefault,
    getChannelsHasSetDefaultQuery: state => state.channelsHasSetDefaultQuery,
    getChannelsQuery: state => state.channelsQuery,
    getChannelsRoFQuery: state => state.channelsRoFQuery,
    getChannelsQueryForApi: state => state.channelsQueryForApi,
    getChannelsExportQuery: state => state.channelsExportQuery,
    getChannelsResults: state => state.channelsResults,
    getChannelsRoFResults: state => state.channelsRoFResults,
    getChannelsHaveSelectedRow: state => state.channelsHaveSelectedRow,
    getChannelsColumnTypes: ({ channelsColumnTypes }) => channelsColumnTypes,
    getChannelsInitStatus: ({ channelsInitStatus }) => channelsInitStatus,
    getChannelsDefaultColumns: state => state.channelsDefaultColumns,
    getChannelsProviders: state => state.channelsProviders,
    getChannelsSelectedChannelInfo: state => state.channelsSelectedChannelInfo,
    getChannelsQueryCost: state => state.queryCost,
    getChannelsQueryBeforeChange: state => state.channelsQueryBeforeChange,
    getChannelsStringForFilterBeforeChange: state => state.channelsStringForFilterBeforeChange,
    getChannelsHasExcludedRow: state => state.channelsHasExcludedRow,
    getChannelsExcludedRows: state => state.channelsResults.data.excludedRows,
    getChannelsSumVisible: state => state.channelsSumVisible,
}

const mutations = {
    [Mutations.setChannelsQuery]: (state, payload) => (state.channelsQuery = payload),
    [Mutations.setChannelsQueryDefault]: (state, payload) => (state.channelsQueryDefault = payload),
    [Mutations.setChannelsHasSetDefaultQuery]: (state, payload) => (state.channelsHasSetDefaultQuery = payload),
    [Mutations.setChannelsRoFQuery]: (state, payload) => (state.channelsRoFQuery = payload),
    [Mutations.setChannelsQueryForApi]: (state, payload) => (state.channelsQueryForApi = payload),
    [Mutations.setChannelsExportQuery]: (state, payload) => (state.channelsExportQuery = payload),
    [Mutations.setChannelsQueryProviders]: (state, payload) => (state.channelsQuery.provider_keys = payload),
    [Mutations.setChannelsResults]: (state, payload) => (state.channelsResults = payload),
    [Mutations.setChannelsRoFResults]: (state, payload) => (state.channelsRoFResults = payload),
    [Mutations.setChannelsRoFResultsTableData]: (state, payload) => (state.channelsRoFResults.tableData = payload),
    [Mutations.setChannelsHaveSelectedRow]: (state, payload) => (state.channelsHaveSelectedRow = payload),
    [Mutations.setChannelsColumnTypes]: (state, payload) => (state.channelsColumnTypes = payload),
    [Mutations.setChannelsInitStatus]: (state, payload) => (state.channelsInitStatus = payload),
    [Mutations.setChannelsStartdate]: (state, payload) => (state.channelsQuery.start_date = payload),
    [Mutations.setChannelsEnddate]: (state, payload) => (state.channelsQuery.end_date = payload),
    [Mutations.setChannelsDefaultColumns]: (state, payload) => (state.channelsDefaultColumns = payload),
    [Mutations.setChannelsProviders]: (state, payload) => (state.channelsProviders = payload),
    [Mutations.setChannelsSelectedChannelInfo]: (state, payload) => (state.channelsSelectedChannelInfo = payload),
    [Mutations.setQueryCostData]: (state, payload) => (state.queryCost.data = payload),
    [Mutations.setQueryCostLoading]: (state, payload) => (state.queryCost.loading = payload),
    [Mutations.setQueryCostError]: (state, payload) => (state.queryCost.error = payload),
    [Mutations.setChannelsQueryBeforeChange]: (state, payload) => (state.channelsQueryBeforeChange = payload),
    [Mutations.setChannelsStringForFilterBeforeChange]: (state, payload) => (state.channelsStringForFilterBeforeChange = payload),
    [Mutations.setChannelsHasExcludedRow]: (state, payload) => (state.channelsHasExcludedRow = payload),
    [Mutations.setChannelsExcludedRows]: (state, payload) => (state.channelsResults.data.excludedRows = payload),
    [Mutations.setChannelsSumVisible]: (state, payload) => (state.channelsSumVisible = payload),
}

export default {
    state,
    getters,
    mutations,
    actions,
}
